import TasksHeaderSvg from '@lib/core/src/assets/images/tasks-widget.svg';
import palette from '@lib/core/src/theme/palette';
import { Box, Stack, styled } from '@mui/material';

export const TASKS_HEADER_HEIGHT = 109;

export const TasksContainer = styled(Stack)({
  height: `calc(100%- ${TASKS_HEADER_HEIGHT}px)`,
  alignItems: 'center',
  gap: '12px',
  width: '100%',
  justifyContent: 'space-between',
  backgroundColor: palette.white,
  borderTop: `1px solid ${palette.grey[1200]}`,
  overflow: 'hidden',
  padding: '0 6px'
});

export const TasksContainerInner = styled(Box)({
  height: '100%',
  width: '100%',
  overflow: 'auto'
});

export const HeaderContainer = styled(Stack)({
  padding: '0 0 33px 20px',
  position: 'relative',
  overflow: 'hidden',
  gap: '7px',
  justifyContent: 'space-between',
  height: TASKS_HEADER_HEIGHT
});

export const Row = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center'
});

export const HeaderImage = styled(Box)({
  position: 'absolute',
  top: 0,
  right: '-22px',
  width: '120px',
  height: '88px',
  backgroundImage: `url(${TasksHeaderSvg})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  borderRadius: '6px',
  boxShadow: '0px 8px 18px -6px rgba(24, 39, 75, 0.12), 0px 12px 42px -4px rgba(24, 39, 75, 0.12)'
});
